<template>
  <a-button
    type="text"
    @click="
      handleShowModal();
      $emit('click');
    "
    :disabled="itemmotive.status === 2"
  >
    <template #icon>
      <PlusOutlined type="link" size="small" />
    </template>

    Agregar nuevo submotivo
  </a-button>

  <a-drawer
    :visible="visible"
    title="Agregar nuevo submotivo"
    width="400px"
    centered
    :mask-closable="false"
    :keyboard="false"
    @close="handleConfirmationClose"
  >
    <div class="title">
      <div class="group">
        <h4>Grupo:</h4>
        <h5>{{ itemgroup.name }}</h5>
      </div>
      <div class="result group">
        <h4>Resultado:</h4>
        <h5>{{ itemresult.name }}</h5>
        <div class="result">
          <h4>Motivo:</h4>
          <h5>{{ itemmotive.name }}</h5>
        </div>
      </div>
    </div>
    <a-form ref="formRef" :model="formState" :rules="rules" layout="vertical">
      <a-form-item label="Nombre del submotivo" name="name">
        <a-input v-model:value="formState.name" placeholder="Escribir nombre del submotivo" />
      </a-form-item>

      <a-form-item name="code">
        <template #label>
          <span class="label">
            Código de integración
            <a-tooltip>
              <template v-slot:title>
                Código de identificación para exportaciones o integraciones
              </template>
              <InfoCircleOutlined />
            </a-tooltip>
          </span>
        </template>
        <a-input v-model:value="formState.code" placeholder="Escribir código aquí..." />
      </a-form-item>
    </a-form>

    <fixed-footer
      confirmText="Agregar submotivo"
      @onCancel="handleCancel"
      @onConfirm="handleOk"
      cancelText="Cancelar"
    />
  </a-drawer>
</template>

<script>
import { defineComponent, reactive, ref, toRaw, createVNode } from "vue";
import { InfoCircleOutlined, PlusOutlined, QuestionCircleOutlined } from "@ant-design/icons-vue";
import FixedFooter from "@/app/shared/components/sections/FixedFooter.vue";
import { Modal } from "ant-design-vue";

export default defineComponent({
  components: {
    FixedFooter,
    InfoCircleOutlined,
    PlusOutlined,
  },
  props: {
    itemgroup: {
      required: true,
      type: Object,
    },
    itemresult: {
      required: true,
      type: Object,
    },
    itemmotive: {
      required: true,
      type: Object,
    },
  },
  setup() {
    const formRef = ref();
    const formState = reactive({
      name: "",
      code: "",
    });
    const rules = {
      name: [{ required: true, message: "Campo requerido" }],
      code: [],
    };

    return {
      formRef,
      formState,
      rules,
    };
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    handleOk() {
      this.formRef.validateFields().then(() => {
        let values = toRaw(this.formState);
        this.$emit("push", {
          ...values,
          status: 1,
          children: [],
          type: "submotive",
          group: this.itemgroup.id,
          result: this.itemresult.id,
          order: this.itemmotive.order + "." + (this.itemmotive.children.length + 1),
          motive: this.itemmotive.id,
        });
        this.visible = false;
        this.formRef.resetFields();
      });
    },
    handleShowModal() {
      this.visible = true;
    },
    handleCancel() {
      this.visible = false;
    },
    handleConfirmationClose() {
      Modal.confirm({
        title: "¿Estás seguro de descartar cambios?",
        content: "Al cerrar no se guardarán los datos previamente ingresados",
        icon: createVNode(QuestionCircleOutlined),
        onOk: () => this.handleCancel(),
        centered: true,
        okText: "Descartar",
        cancelText: "Cancelar",
      });
    },
  },
});
</script>

<style lang="sass" scoped>
.result
  margin-left: 28px
  margin-top: 18px

.title
  margin-bottom: 24px

.link
  text-decoration: underline
</style>
